import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import { ZOOM_ICON } from "js/config.jsx";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import DOCKER_ADVANCED_SCREENSHOT from "resources/img/docker-advanced-screenshot.png";
import facetec_dev_mode_watermark from "resources/img/facetec-dev-mode-watermark.png";

import GETTING_STARTED_PROGUARD from "resources/code/getting-started/proguard.bash.tpl";
import GETTING_STARTED_ANDROID_PERSMISSIONS from "resources/code/getting-started/android-permissions.java.tpl";

export default React.createClass({
  displayName: "RemoveDevMode",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container zoom_docker">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="removing-development-mode-watermark">Removing the "Development Mode" Watermark</h2>
                </div>
                <p>During initial integration, while you are using Development Keys, your Progress and Success Screen will look like the below screenshot.  </p>
              </section>

              <section>
                  <p style={{textAlign: "left"}}><img style={{marginTop: "1px"}} src={facetec_dev_mode_watermark}  width="80%" /></p>
                <h4 id="how-to-remove-the-watermark">How to Remove the Watermark</h4>
                  <p>Once you are in Production Mode, the Development Mode text will not appear in your App.</p>
                <h4 id="developers-without-commercial-agreements">Developers Without Commercial Agreements</h4>
                 <p>Please see <Link to="/quote">Request a Pricing Quote</Link> to move your Development App into Production..</p>
                <h4 id="facetec-partners-and-customers-agreements">FaceTec Partners and Customers With Commercial Agreements</h4>
                 <p>Please see the <Link to="/going-production-overview">Going Production Overview</Link> to move your Development App into Production.</p>
              </section>

              <SDKSidebar menuType="main" title="FaceTec Browser Docker Help"/>
            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/removing-development-mode-watermark.jsx